import React from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { CreateRenewalForm } from '@/components/forms/CreateRenewalForm';
import { PoliciesSelectProvider } from '@/context/policiesContext';

export const CreateRenewalPage = () => {
	return (
		<AuthenticatedPageLayout>
			<PoliciesSelectProvider>
				<CreateRenewalForm />
			</PoliciesSelectProvider>
		</AuthenticatedPageLayout>
	);
};
